import { Link } from 'react-router-dom';
import { TIER_LIMITS } from '@mockd/shared';
import { Cursor, LoadingLabel } from '../common/Cursor';
import { Prompt, Terminal } from './Terminal';

interface CallToActionProps {
  onQuickStart: () => void;
  isLoading?: boolean;
}

export function CallToAction({ onQuickStart, isLoading }: CallToActionProps) {
  return (
    <section className="py-20 bg-base-200 border-t border-base-300">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl tracking-tight">Ready to mock your first API?</h2>
        <p className="mt-3 text-lg text-base-content/70 max-w-2xl">
          One click to a live URL. No credit card, no server, no config.
        </p>

        {/* The request log's empty state (docs/brand.md → Terminal and request log). */}
        <Terminal className="mt-8 max-w-3xl">
          <span className="wrap-break-word">
            <Prompt />
            waiting for requests on https://your-project.mockd.sh
            <Cursor />
          </span>
        </Terminal>

        <div className="mt-6 flex flex-wrap gap-3">
          <button
            onClick={onQuickStart}
            disabled={isLoading}
            className="btn btn-primary btn-lg"
          >
            {isLoading ? (
              <LoadingLabel>Creating your mock</LoadingLabel>
            ) : (
              'Try it now — free'
            )}
          </button>
          <Link to="/pricing" className="btn btn-outline btn-lg">
            View pricing
          </Link>
        </div>
        <p className="mt-6 text-sm text-base-content/70">
          Free tier includes {TIER_LIMITS.free.projects} projects, {TIER_LIMITS.free.endpointsPerProject} endpoints each, and {TIER_LIMITS.free.logRetentionDays}-day data retention.
        </p>
      </div>
    </section>
  );
}
